import { HostListener, ViewChild } from "@angular/core";
import { App, Content, MenuController, Platform } from "ionic-angular";
import { UserProvider } from "../providers/user";
import { NotificationsProvider } from "../providers/notifications";
import { InAppBrowser } from "@ionic-native/in-app-browser";

export class MyController {
    @ViewChild(Content) content: Content;

    private _appTitle: string = "Área do Associado - Recreio da Juventude";
    private _resizeTimer: any = false;

    public isMobile: boolean;
    public unread: number = 0;

    protected restrict: boolean = true; // Página necessita estar logado
    protected need_auth: boolean = true; // Páginas que são restritas e podem ser acessadas externamente
    protected pageTitle: string;
    protected currentPage: string;

    public firebasePlugin;
    public iab: InAppBrowser;

    constructor(
        protected _app: App,
        protected _menu: MenuController,
        public user: UserProvider,
        public platform: Platform
    ) {
        this.iab = new InAppBrowser();
        this.firebasePlugin = (<any>window).FirebasePlugin;
        // Seta versão do app (mobile/desktop)
        this.isMobile = window.innerWidth < 960;
        // Bloqueia menu nas páginas restritas ou na versão desktop
        if (!this.restrict || !this.isMobile) {
            this._menu.swipeEnable(false);
        }
        // Ajusta conteúdo conforme versão setada
        setTimeout(() => {
            this.content.resize();
        }, 150);
        // Pega nome do módulo atual
        this.currentPage = this.constructor.name;
    }

    @HostListener("window:resize", ["$event"])
    onResize(event) {
        // Limpa o timer caso o usuário esteja resizeando freneticamente
        if (this._resizeTimer !== false) {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = false;
        }
        // Seta timer para o resize:
        this._resizeTimer = setTimeout(() => {
            let mobile = event.target.innerWidth < 960;
            let oldMobile: boolean = this.isMobile;
            this.isMobile = mobile;
            // Caso haja mudança de plataforma (desktop / mobile)
            if ((oldMobile && !mobile) || (!oldMobile && mobile)) {
                // Fecha o menu se estiver aberto
                if (this._menu.isOpen()) {
                    this._menu.close();
                }
                // Bloqueia/Libera swipe do menu de acordo com plataforma
                this._menu.swipeEnable(mobile);
                // Ajusta conteúdo conforme versão setada
                setTimeout(() => {
                    this.content.resize();
                }, 150);
            }
        }, 200);
    }

    ionViewCanEnter() {
        return new Promise((resolve, reject) => {
            this.user.authenticated().then((data) => {
                if (!this.need_auth) {
                    resolve(true);
                }
                if (
                    (this.restrict && data != null) ||
                    (!this.restrict && data == null)
                ) {
                    resolve(true);
                } else {
                    reject(true);
                }
            });
        });
    }

    ionViewDidEnter() {
        this.setTitle();
        setTimeout(() => {
            this.setTitle();
        }, 150);
    }

    isRestricted(): boolean {
        return this.restrict;
    }

    protected setTitle() {
        let title: string = this.pageTitle
            ? this.pageTitle + " - " + this._appTitle
            : this._appTitle;
        this._app.setTitle(title);
    }

    public openLink(file: string, target = "_system") {
        return this.iab.create(file, target);
    }

    public firebaseLog(eventName: string, eventParams: any) {
        if (this.platform.is("android") || this.platform.is("ios")) {
            // this.firebasePlugin.logEvent(eventName, eventParams);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/my-controller.ts